import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getClosestWidthTier from "app/media/helpers/getClosestWidthTier";
import { UmbracoImageCrop, UmbracoImageFocalPoint } from "../models/media.interface";

export default (
    src: string,
    clientWidth: number,
    extensionType?: string,
    crop?: UmbracoImageCrop,
    focalPoint?: UmbracoImageFocalPoint,
    heightRatio?: number
): string => {
    const imageUrl = urlBuilder(src);
    const params = new URLSearchParams();

    // Search for closest value to only have 5 different image sizes to cache.
    const imageWidth = getClosestWidthTier(clientWidth);
    params.set("width", imageWidth.toString());

    if (typeof heightRatio !== "undefined") {
        params.set("height", Math.round(imageWidth * heightRatio).toString());
        params.set("rmode", "crop");
    }

    if (focalPoint) {
        params.set("rxy", `${focalPoint.left},${focalPoint.top}`);
    }

    params.set("upscale", "true");
    params.set("format", extensionType || "jpg");

    if (extensionType === "jpg" || extensionType === "jpeg") {
        params.set("bgcolor", "white");
    }
    else if (extensionType === "png" || extensionType === "gif") {
        params.set("bgcolor", "transparent");
    }

    const querySeparator = imageUrl.toString().indexOf("?") > 0 ? "&" : "?";

    return `${imageUrl}${querySeparator}${params.toString()}`;
};
